import { render, staticRenderFns } from "./TemporaryAccesses.vue?vue&type=template&id=77d66eeb&scoped=true"
import script from "./TemporaryAccesses.vue?vue&type=script&lang=js"
export * from "./TemporaryAccesses.vue?vue&type=script&lang=js"
import style0 from "./TemporaryAccesses.vue?vue&type=style&index=0&id=77d66eeb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d66eeb",
  null
  
)

export default component.exports